import { render, staticRenderFns } from "./submissionPanel.vue?vue&type=template&id=2d66c6ce&scoped=true&"
import script from "./submissionPanel.vue?vue&type=script&lang=ts&"
export * from "./submissionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./submissionPanel.vue?vue&type=style&index=0&id=2d66c6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66c6ce",
  null
  
)

export default component.exports